import PropTypes from 'prop-types';
import { ThemeProvider } from 'emotion-theming';
import { css } from '@emotion/core';
import SearchBox from '@veeva/corgix/searchbox';
import { Option } from '@veeva/corgix/select';
import SelectField from '../../components/SelectField';
import mobileContentWidthCSS from '../../constants/mobileContentWidthCSS';
import StudiesDataSortOptions from '../../constants/StudiesDataSortOptions';

const theme = {
    textInputHeight: '3.3333rem',
};

const StudiesTitleMobile = ({
    searchTerm,
    handleSearch,
    searchPlaceholder,
    handleSortChange,
    sortOption,
    lastLoginTimeLabel,
    companyNameLabel,
    loading,
}) => {
    const handleChange = (e, value) => {
        handleSearch(value);
    };

    const handleClear = () => {
        handleSearch('');
    };

    return (
        <ThemeProvider theme={theme}>
            <div
                css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    padding-bottom: 1rem;
                `}
            >
                <SearchBox
                    css={css`
                        border-radius: 8px;
                        ${mobileContentWidthCSS}
                    `}
                    value={searchTerm}
                    onChange={handleChange}
                    onSearch={handleSearch}
                    onClear={handleClear}
                    placeholder={searchPlaceholder}
                    disabled={loading}
                />
                <SelectField
                    displayFieldCSS={css`
                        & > div > div:nth-of-type(2) {
                            display: none;
                        }
                    `}
                    menuFontSize="1rem"
                    disabled={loading}
                    onChange={handleSortChange}
                    value={sortOption}
                >
                    <Option value={StudiesDataSortOptions.LASTLOGIN} label={lastLoginTimeLabel}>
                        {lastLoginTimeLabel}
                    </Option>
                    <Option value={StudiesDataSortOptions.COMPANYNAME} label={companyNameLabel}>
                        {companyNameLabel}
                    </Option>
                </SelectField>
            </div>
        </ThemeProvider>
    );
};

StudiesTitleMobile.propTypes = {
    companyNameLabel: PropTypes.string,
    handleSearch: PropTypes.func,
    handleSortChange: PropTypes.func,
    lastLoginTimeLabel: PropTypes.string,
    loading: PropTypes.bool,
    searchPlaceholder: PropTypes.string,
    searchTerm: PropTypes.string,
    sortOption: PropTypes.oneOf(Object.values(StudiesDataSortOptions)),
};

export default StudiesTitleMobile;
